// (function () {
//   var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

//   function init() {
//     var buttons = document.querySelectorAll('.voice-search__btn');
//     if (!buttons.length) return;

//     // Hide mic buttons on browsers that don't support the API (Firefox without flag, etc.)
//     if (!SpeechRecognition) {
//       buttons.forEach(function (btn) { btn.style.display = 'none'; });
//       return;
//     }

//     buttons.forEach(function (btn) {
//       var form  = btn.closest('form');
//       var input = form && form.querySelector('input[type="search"]');
//       if (!input) return;

//       var recognition  = new SpeechRecognition();
//       recognition.continuous     = false;
//       recognition.interimResults = false;
//       recognition.lang           = document.documentElement.lang || 'en';

//       var listening   = false;
//       var autoSubmit  = null;

//       /* ── Focus guard ──────────────────────────────────────────────────
//          Prevent the mic button from stealing focus from the search input
//          when clicked. This keeps the predictive-search onFocusOut check
//          from triggering a modal close (the input, which IS inside the
//          predictive-search element, keeps focus the whole time).
//       ─────────────────────────────────────────────────────────────────── */
//       btn.addEventListener('mousedown', function (e) {
//         e.preventDefault(); // focus stays on input — no focusout fires
//       });

//       btn.addEventListener('click', function () {
//         clearTimeout(autoSubmit);

//         if (listening) {
//           recognition.stop();
//           return;
//         }

//         // Return focus to the input before starting recognition so that
//         // even if the browser microphone prompt briefly blurs the page,
//         // focus is restored before the 100 ms onFocusOut window expires.
//         input.focus();

//         try {
//           recognition.start();
//         } catch (e) {
//           // Guard against "recognition already started" error on double-click
//         }
//       });

//       /* ── Recognition lifecycle ────────────────────────────────────── */

//       recognition.onstart = function () {
//         listening = true;
//         btn.classList.remove('voice-search__btn--error');
//         btn.classList.add('voice-search__btn--listening');
//         btn.setAttribute('aria-label', 'Listening… click to stop');
//         input.focus(); // belt-and-suspenders focus restore
//       };

//       recognition.onresult = function (event) {
//         var transcript = event.results[0][0].transcript.trim();
//         input.value = transcript;

//         // Fire the native input event so predictive-search picks it up
//         // exactly as if the user had typed the word.
//         input.dispatchEvent(new Event('input', { bubbles: true }));
//         input.focus();

//         // After 1 s the user has seen the predictive results;
//         // auto-submit to the full search results page.
//         autoSubmit = setTimeout(function () {
//           if (input.value.trim()) {
//             // requestSubmit fires submit-event listeners; fall back to
//             // plain submit() on browsers that don't support it.
//             if (typeof form.requestSubmit === 'function') {
//               form.requestSubmit();
//             } else {
//               form.submit();
//             }
//           }
//         }, 1000);
//       };

//       recognition.onnomatch = function () {
//         // Browser heard speech but couldn't match anything — reset quietly
//         listening = false;
//         btn.classList.remove('voice-search__btn--listening');
//         btn.setAttribute('aria-label', 'Search by voice');
//       };

//       recognition.onerror = function (event) {
//         listening = false;
//         clearTimeout(autoSubmit);
//         btn.classList.remove('voice-search__btn--listening');
//         btn.setAttribute('aria-label', 'Search by voice');

//         if (event.error === 'not-allowed' || event.error === 'permission-denied') {
//           // Microphone access was denied — give visible feedback for 3 s
//           btn.classList.add('voice-search__btn--error');
//           btn.setAttribute('aria-label', 'Mic blocked — check browser permissions');
//           setTimeout(function () {
//             btn.classList.remove('voice-search__btn--error');
//             btn.setAttribute('aria-label', 'Search by voice');
//           }, 3000);
//         }
//         // 'no-speech', 'audio-capture', 'network' etc. → silently reset
//       };

//       recognition.onend = function () {
//         listening = false;
//         btn.classList.remove('voice-search__btn--listening');
//         btn.setAttribute('aria-label', 'Search by voice');
//       };
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();



(function () {
  var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

  function init() {
    var buttons = document.querySelectorAll('.voice-search__btn');

    // tablet safari work only
    const isIOSChrome = /CriOS/i.test(navigator.userAgent);
    if (isIOSChrome) {
      document.querySelectorAll('.voice-search__btn').forEach(btn => {
        btn.style.display = 'none';
      });
    }
    // end

    if (!buttons.length) return;

    if (!SpeechRecognition) {
      buttons.forEach(function (btn) { btn.style.display = 'none'; });
      return;
    }

    buttons.forEach(function (btn) {
      var idleLabel = btn.dataset.labelIdle || 'Search by voice';
      var listeningLabel = btn.dataset.labelListening || 'Listening… click to stop';
      var blockedLabel = btn.dataset.labelBlocked || 'Microphone blocked — check browser permissions';
      var form = btn.closest('form');
      var input = form && form.querySelector('input[type="search"]');
      if (!input) return;

      var recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = document.documentElement.lang || 'en';

      var listening = false;
      var autoSubmit = null;

      btn.addEventListener('click', function (e) {
        // Prevent the form from submitting prematurely if the button is inside a form
        e.preventDefault();
        
        clearTimeout(autoSubmit);

        if (listening) {
          recognition.stop();
          return;
        }

        // Small timeout ensures the browser has processed the touch interaction
        // before requesting access to the microphone.
        setTimeout(function() {
          input.focus();
          try {
            recognition.start();
          } catch (err) {
            console.error("Recognition start error:", err);
          }
        }, 100);
      });

      /* ── Recognition lifecycle ────────────────────────────────────── */

      recognition.onstart = function () {
        listening = true;
        btn.classList.remove('voice-search__btn--error');
        btn.classList.add('voice-search__btn--listening');
        btn.setAttribute('aria-label', listeningLabel);
      };

      recognition.onresult = function (event) {
        var transcript = event.results[0][0].transcript.trim();
        input.value = transcript;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();

        autoSubmit = setTimeout(function () {
          if (input.value.trim()) {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          }
        }, 1000);
      };

      recognition.onnomatch = function () {
        listening = false;
        btn.classList.remove('voice-search__btn--listening');
        btn.setAttribute('aria-label', idleLabel);
      };

      recognition.onerror = function (event) {
        listening = false;
        clearTimeout(autoSubmit);
        btn.classList.remove('voice-search__btn--listening');
        btn.setAttribute('aria-label', idleLabel);

        if (event.error === 'not-allowed' || event.error === 'permission-denied') {
          btn.classList.add('voice-search__btn--error');
          btn.setAttribute('aria-label', blockedLabel);
          setTimeout(function () {
            btn.classList.remove('voice-search__btn--error');
            btn.setAttribute('aria-label', idleLabel);
          }, 3000);
        }
      };

      recognition.onend = function () {
        listening = false;
        btn.classList.remove('voice-search__btn--listening');
        btn.setAttribute('aria-label', idleLabel);
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
